import { curry, type PlatformEvent } from 'lib/util'

/**
 *
 * @param module    current module
 * @param component event source
 * @param event     triggered event
 */
const getBluetoothPeripheralName = async (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: PlatformEvent,
): Promise<string> => {
  const { sensor: model } = module[G.MODEL][G.CHILDREN]
  const modelCache = model[G.CACHE]

  return modelCache.value.name
}

export default curry(getBluetoothPeripheralName)
